import { z } from "zod";
export const FeatureFlagStateSchema = z.enum(["on", "off"]);
export const FeatureFlagDefinitionSchema = z.object({
    key: z
        .string()
        .min(1)
        .max(80)
        .regex(/^[a-z0-9][a-z0-9._-]*$/),
    description: z.string().max(500).optional(),
    enabled: z.boolean().default(false),
    rolloutPercent: z.number().int().min(0).max(100).default(0),
    tenants: z.array(z.string().regex(/^[a-z0-9-]+$/)).default([]),
    roles: z.array(z.enum(["admin", "exec", "sales", "board", "client"])).default([]),
    users: z.array(z.string().email()).default([]),
});
export const FeatureFlagEvaluationSchema = z.object({
    key: FeatureFlagDefinitionSchema.shape.key,
    state: FeatureFlagStateSchema,
    enabled: z.boolean(),
    reason: z.enum(["global", "tenant", "role", "user", "rollout", "disabled"]),
    rolloutPercent: z.number().int().min(0).max(100),
    source: z.enum(["env", "default"]),
});
export const FeatureFlagListResponseSchema = z.object({
    flags: z.array(FeatureFlagEvaluationSchema),
});
//# sourceMappingURL=feature-flags.js.map